import { FILE_ALLOW_SIZE } from '../constants';
import toast from 'react-hot-toast'

const ErrorMessage = 'File size exceeds 3MB limit. Please select a smaller file.'

export const checkFileSize = (e) => {
  const file = e.target.files[0];

  if (file && file.size > FILE_ALLOW_SIZE) {
    e.target.value = null;
    toast.error(ErrorMessage);
    throw new Error(ErrorMessage)
  }
};
